<ma-task-modal
  [task]="state.task"
  [taskInfos]="state.taskInfos"
  [pictureId]="state.toolingPictureId"
  [details]="state.details"
>
</ma-task-modal>
